export function pathsMatch(dynamicPath: string, realPath: string) {
  // Escape special regex characters in the dynamic path
  const escapedDynamicPath = dynamicPath.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

  // Replace ":param" with a regex pattern to match dynamic segments
  const regexPattern = escapedDynamicPath.replace(/:([a-zA-Z]+)/g, '[\\w-]+');

  // Create a full regex to match the entire path
  const regex = new RegExp(`^${regexPattern}$`);

  // Test the real path against the regex
  return regex.test(realPath);
}

export function camelCase(str: string) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}
